/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface TimelineEntry
 */
export interface TimelineEntry {
  /**
   *
   * @type {OffsetDateTime}
   * @memberof TimelineEntry
   */
  at: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof TimelineEntry
   */
  by: string;
  /**
   *
   * @type {string}
   * @memberof TimelineEntry
   */
  kind: string;
  /**
   *
   * @type {string}
   * @memberof TimelineEntry
   */
  summary: string;
}

/**
 * Check if a given object implements the TimelineEntry interface.
 */
export function instanceOfTimelineEntry(value: object): value is TimelineEntry {
  if (!("at" in value) || value["at"] === undefined) return false;
  if (!("by" in value) || value["by"] === undefined) return false;
  if (!("kind" in value) || value["kind"] === undefined) return false;
  if (!("summary" in value) || value["summary"] === undefined) return false;
  return true;
}

export function TimelineEntryFromJSON(json: any): TimelineEntry {
  return TimelineEntryFromJSONTyped(json, false);
}

export function TimelineEntryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TimelineEntry {
  if (json == null) {
    return json;
  }
  return {
    at: json["at"],
    by: json["by"],
    kind: json["kind"],
    summary: json["summary"],
  };
}

export function TimelineEntryToJSON(json: any): TimelineEntry {
  return TimelineEntryToJSONTyped(json, false);
}

export function TimelineEntryToJSONTyped(
  value?: TimelineEntry | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    at: value["at"],
    by: value["by"],
    kind: value["kind"],
    summary: value["summary"],
  };
}
